<script setup>
import { computed } from 'vue';
import { useCommonStore } from '~/common/stores/common.store.js';

const props = defineProps({
  uid: {
    type: String,
    default: '',
  },
  // eslint-disable-next-line vue/prop-name-casing
  truncate_length: {
    type: Number,
    default: 30,
  },
  useHawkText: {
    type: Boolean,
    default: false,
  },
});

const common_store = useCommonStore();

const category = computed(() => common_store.get_category(props?.uid));
</script>

<template>
  <div v-if="props.uid && category?.name" class="text-gray-600 text-sm" :class="!useHawkText ? 'whitespace-nowrap' : ''">
    <span v-if="useHawkText">{{ category?.name }}</span>
    <HawkText v-else :content="category?.name" :length="truncate_length" />
  </div>
  <div v-else>
    {{ '-' }}
  </div>
</template>
